<template>
  <div id="home">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><a href="javascript:;">Home</a></li>
      <li><a href="javascript:;">Dashboard</a></li>
      <li class="active">Dashboard</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Dashboard <small>this is an example of dashboard page...</small></h1>
    <!-- end page-header -->
  </div>
</template>
<script>
import auth from '@/services/auth.js'

export default {
  name: 'home',
  beforeCreate: function() {
    if(!this.$store.state.auth.loggedIn) {
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?03930cb1